import {
  FEMALE,
  MALE
} from '@mos-front-components/public/es/components/MainData/MainData';

export const mapGender = serverGender => {
  if (serverGender === 'm') {
    return MALE;
  }
  if (serverGender === 'f') {
    return FEMALE;
  }
  return null;
};

export const genderFromServer = serverGender => {
  if (serverGender === MALE) {
    return 'MALE';
  }
  if (serverGender === FEMALE) {
    return 'FEMALE';
  }
  return null;
};
